import PartySocket from "partysocket";
import type { ClientMsg, ServerMsg } from "@genjiball/protocol";

type Listener = (msg: ServerMsg) => void;

export class NetClient {
  private socket: PartySocket;
  private listeners: Set<Listener> = new Set();

  constructor(opts: { host: string; room: string }) {
    this.socket = new PartySocket({
      host: opts.host,
      room: opts.room,
      party: "main",
    });

    this.socket.addEventListener("message", (event) => {
      let msg: ServerMsg;
      try {
        msg = JSON.parse(event.data as string) as ServerMsg;
      } catch {
        return;
      }
      for (const l of this.listeners) l(msg);
    });

    this.socket.addEventListener("open", () => {
      console.log("[net] open");
    });
    this.socket.addEventListener("close", (e) => {
      console.log("[net] close", e.code, e.reason);
    });
  }

  on(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  send(msg: ClientMsg): void {
    this.socket.send(JSON.stringify(msg));
  }

  close(): void {
    this.socket.close();
  }
}

export function partykitHostFromOrigin(): string {
  // VITE_PARTYKIT_HOST is the deployed PartyKit hostname, set at build time
  // (e.g. "genjiball.username.partykit.dev"). Falls back to the local dev
  // host when the env var is missing — keeps `pnpm dev` working without
  // any extra config.
  const envHost = (import.meta.env.VITE_PARTYKIT_HOST as string | undefined)?.trim();
  if (envHost) return envHost;
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return "127.0.0.1:1999";
  }
  return window.location.host;
}
